import React, { ReactNode, memo, useMemo } from 'react';

interface StampDutyFormFieldProps {
  label: string;
  description?: string;
  errorMessage?: string;
  children: ReactNode;
}

const StampDutyFormField: React.FC<StampDutyFormFieldProps> = ({
  label,
  children,
}) => {
  return (
    <div className="space-y-2">
      <div className="flex items-center justify-start gap-x-3">
        <label className="font-dm-sans font-bold text-text/body block">
          {label}
        </label>
      </div>
      {children}
    </div>
  );
};

export default memo(StampDutyFormField);
